import React from 'react';
import { useScreenWitdh } from '../../../../../core/hooks/useScreenWidth';
import { responsiveEndpointsEnum } from '../../../../../core/enums/responsiveEndpointsEnum';
import Selectable from '../../../../../core/components/selectable/Selectable';
import Segmented from '../../../../../core/components/segmented/Segmented';

type EmployeeViewPageTabsProps = {
  tabs: { label: string, value: string }[],
  currentTab: string,
  setModeParams: (value: string) => void,
}
const EmployeeViewPageTabs: React.FC<EmployeeViewPageTabsProps> = ({ tabs, currentTab, setModeParams }) => {
  const { windowWidth } = useScreenWitdh();

  return (
    <div className="employeeViewPageTabs">
      {windowWidth && windowWidth < responsiveEndpointsEnum.XL
        ? <Selectable
          options={tabs}
          value={currentTab}
          onChange={(value) => setModeParams(value as string)}
        />
        : <Segmented
          options={tabs}
          value={currentTab}
          onChange={(value) => setModeParams(value as string)}
        />}
    </div>
  );
};

export default EmployeeViewPageTabs;
